export const AMOUNT_OFF_TABLE_OPTIONS = [
  5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
  100,
].map((percentage) => ({
  label: `${percentage}%`,
  value: percentage,
}));
